<div class="collaborators-container">
  <div class="collaborators-search-section">
    <app-user-search (onUserSelected)="onAddTaskUser($event)" [forSearchBar]="true" [showCreateUser]="false"></app-user-search>
  </div>

  @if (taskUsers && taskUsers.length > 0) {
    <div class="collaborators-table-section">
      <p-table [value]="taskUsers" dataKey="userId" editMode="row" [styleClass]="'collaborators-table'">
        <ng-template pTemplate="header">
          <tr>
            <th class="table-header-name">Name</th>
            <th class="table-header-dept">Department</th>
            <th class="table-header-permission">Permission</th>
            <th class="table-header-actions">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
          <tr [pEditableRow]="rowData" class="table-row">
            <td class="table-cell-name">
              <span class="user-name">{{rowData.user.firstName}} {{rowData.user.lastName}}</span>
            </td>
            <td class="table-cell-dept">
              <span class="user-dept">{{rowData.user.department}}/{{rowData.user.city}}</span>
            </td>
            <td class="table-cell-permission">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-dropdown [options]="permissions" optionLabel="name" dataKey="permissions.value" [(ngModel)]="rowData.permission"
                  [styleClass]="'permission-dropdown'"></p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  @if ((rowData.permission)) {
                    <span class="permission-badge">
                      {{permissionsEnum[rowData.permission]}}
                    </span>
                  }
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="table-cell-actions">
              <div class="action-buttons">
                @if (!editing) {
                  <button mat-icon-button matTooltip="Edit access permissions for {{rowData.user.firstName}} {{rowData.user.lastName}}."
                    pInitEditableRow (click)="onRowEditInit(rowData)" class="edit-button">
                    <mat-icon>edit</mat-icon>
                  </button>
                }
                @if (editing) {
                  <button mat-icon-button pSaveEditableRow (click)="onRowEditSave(rowData)" class="save-button">
                    <mat-icon>save</mat-icon>
                  </button>
                }
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="empty-message">
              <div class="empty-state">
                <mat-icon>people_outline</mat-icon>
                <p>No collaborators added yet</p>
                <span>Add collaborators using the search field above</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }

  @if (!taskUsers || taskUsers.length === 0) {
    <div class="empty-state-container">
      <div class="empty-state">
        <mat-icon>people_outline</mat-icon>
        <p>No collaborators added yet</p>
        <span>Add collaborators using the search field above</span>
      </div>
    </div>
  }
</div>
